// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2HrBT","range":"MonthRangeSwitch_range__wMQUb","disabled":"MonthRangeSwitch_disabled__U5jTV"};